<template>
  <div class="bind-wrap">
    <div class="p1">为防止账号丢失及方便找回，请绑定手机号码</div>
    <van-form @submit="onSubmitBind">
      <van-field
        v-model="tel"
        class="phone"
        type="tel"
        placeholder="请输入手机号码"
        ref="tel"
        name="tel"
      />
      <div class="code-box">
        <van-field
          v-model="code"
          class="code-input"
          type="number"
          placeholder="请输入验证码"
          name="code"
        />
        <button class="click-btn" :disabled="disabled" @click="validateBtn">{{ btnTitle }}</button>
      </div>
      <van-button
        class="make_bind"
        native-type="submit"
        :class="{ active: tel != '' && code != '' }"
        >确认绑定</van-button
      >
    </van-form>
    <div
      class="
        text"
    >
      点击代表您已阅读并同意<span @click="userDeal">呼呼打药用户协议</span>
    </div>
  </div>
</template>
<script>
import axios from '../../http';
import { mapMutations } from 'vuex';

export default {
  name: 'bind-phone',
  components: {},
  props: {},
  data() {
    return {
      tel: '',
      code: '',
      disabled: false, //禁用获取获取验证码按钮
      btnTitle: '获取验证码', //获取验证码按钮文案
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {
    ...mapMutations(['setUserType', 'getUserAvatar', 'getUserName', 'getUserPhone', 'getToken']),
    onSubmitBind(values) {
      //提交按钮
      // console.log("val :", val);
      let tel = values.tel;
      let code = values.code;
      if (tel == '') {
        this.$toast('请输入手机号码');
        return;
      } else if (tel.length < 11) {
        this.$toast('请输入正确的号码');
        return;
      }
      if (code == '') {
        this.$toast('请输入验证码');
        return;
      }
      let that = this;
      axios
        .fetchPost('/member/login/register', {
          mobile: this.tel,
          code: this.code,
          business_type: 'h5',
          register_code: this.$route.query.register_code,
        })
        .then((res) => {
          let data = res.data;
          that.getToken(res.data.data.token);
          if (data.code == 200) {
            setTimeout(() => {
              this.$router.push({
                path: '/secondBar/me',
              });
              that.getUserAvatar(res.data.data.avatar);
              that.getUserName(res.data.data.nickname);
              that.getUserPhone(res.data.data.mobile);
              that.setUserType(res.data.data.user_type);
            }, 500);
          } else if (res.data.code == 211) {
            that.$router.push({
              path: '/identity',
              query: { token: res.data.data.token },
            });
          }
          this.$toast(data.msg);
        })
        .catch();
    },
    userDeal() {
      this.$router.push({
        path: '/deal',
      });
    },
    validateBtn() {
      //如果没有手机号码 验证
      if (this.tel.length < 11) {
        this.$refs.tel.focus();
        this.$toast('输入正确的手机号码');
        return;
      }
      let that = this;
      //发送验证码
      axios
        .fetchPost('/member/login/sendsms', { mobile: this.tel })
        .then(function(res) {
          // console.log(res);
          // that.$toast(res.data.msg);
        })
        .catch(function(error) {
          that.$toast(error);
        });
      //倒计时按钮
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.disabled = false;
          this.btnTitle = '获取验证码';
        } else {
          time--;
          this.disabled = true;
          this.btnTitle = `${time}s后重试`;
        }
      }, 1000);
    },
  },
};
</script>
<style lang="stylus" scoped>
.bind-wrap
  padding-top 25px
  .p1
    margin-bottom 14px
    font-size 12px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(152, 152, 152, 1)
  .phone
    width 66%
    margin 0 auto 10px
    border-radius 20px
    color #989898
    border 1px solid rgba(152, 152, 152, 0.5)
    font-size 16px
  .code-box
    width 66%
    margin 0 auto
    display flex
    .code-input
      flex 1
      border-radius 20px
      border 1px solid rgba(152, 152, 152, 0.5)
      border-right none
      border-top-right-radius 0
      border-bottom-right-radius 0
      font-size 16px
    .click-btn
      width 35%
      display inline-block
      color #FF9922
      font-size 13px
      font-family Microsoft YaHei
      line-height 46px
      border 1px solid rgba(152, 152, 152, 0.5)
      border-radius 40px
      height 46px
      text-align center
      border-top-left-radius 0px
      border-bottom-left-radius 0px
      background #fff
  .make_bind
    width 66%
    background rgba(255, 153, 34, 0.3)
    border-radius 40px
    font-size 17px
    font-family Microsoft YaHei
    font-weight 400
    height 40px
    line-height 40px
    margin 55px auto 20px
    color rgba(255, 255, 255, 1)
    &.active
      background rgba(255, 153, 34, 1)
      color #fff
  .text
    font-size 12px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(101, 101, 101, 1)
    line-height 30px
    & > span
      margin-left 10px
      font-size 12px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(255, 153, 34, 1)
</style>
